


/**
 * @classdesc Vague d'une course
 * @kind class
 * @export
 * @prop {int} id - id de la vague
 * @prop {int} id_course - Id de la course
 * @prop {boolean} justificatif - Justificatif obligatoire pour cette vague
 * @prop {boolean} masque_inscrits - Masquer cette vague aux inscrits
 * @prop {string} nom - Nom de la vague
 * @prop {int} nb_inscrits - Nombre d'inscrits à cette vague
 * @prop {int} nombre - Nombre de place total de cette vague
 * @prop {int} places_restantes - Nombre de places restantes à cette vague
 * @prop {boolean} selected - Vague sélectionnée
 * 
 * 
 * @class Vague_Course
 */
export class Vague_Course {
    id;
    id_course;
    justificatif;
    masque_inscrits;
    nom;
    nb_inscrits;
    nombre;
    places_restantes;
    selected = false;

    /**
     * Creates an instance of Vague_Course.
     * @constructs
     * @kind function
     * @memberof Vague_Course
     */
    constructor() { }

    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    is_available(vip_ins) {
        if (vip_ins && vip_ins.limit_acces_parcours == "0") return true;
        if (vip_ins && vip_ins.limit_acces_parcours == "1") { // Si le VIP a accès à certains parcours
            for (let j = 0; j < vip_ins.filter_parcours.length; j++) {
                if (vip_ins.filter_parcours[j].id == this.id_course) { // Si le parcours est dans la liste des parcours autorisé du VIP
                    return true;
                }
            }
        }
        return this.places_restantes > 0;
    }







}